/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import ListMenu from "../listmenus/ListMenu.vue";
const __vue_script__ = {
  name: "ShopMenu",
  components: {
    ListMenu,
  },
  computed: {
    ...mapGetters(["content", "shopsInCurrentCat", "currentShop"]),
    shops() {
      if (this.$store.getters.searchIsOpen) {
        return this.$store.getters.shopSearchResults;
      } else {
        return this.$store.getters.shopsInCurrentCat;
      }
    },
    noticeContent() {
      if (
        this.$store.getters.searchIsOpen &&
        this.$store.getters.shopSearchResults.length <= 0
      ) {
        return this.$store.getters.content.no_search_results;
      } else {
        return false;
      }
    },
    scrollToCurrent() {
      if (this.$store.getters.autoScrollToCurrent && this.$store.getters.currentShop) {
        return this.$store.getters.currentShop;
      } else {
        return null;
      }
    },
  },
  methods: {
    toggleShop(shopId) {
      if (this.$store.getters.currentShop === shopId) {
        this.$store.dispatch('clearShop');
      } else {
        this.$store.dispatch('selectShop', shopId);
        this.$store.dispatch('updatePathFinderTargetShop', null);
      }
    },
  },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ListMenu",
    {
      attrs: { items: _vm.shops, "scroll-to-current": _vm.scrollToCurrent },
      scopedSlots: _vm._u([
        {
          key: "itemContent",
          fn: function (shop) {
            return [
              _c(
                "button",
                {
                  staticClass: "listMenu_link",
                  class: { "st-active": _vm.currentShop === shop.id },
                  on: {
                    click: function ($event) {
                      return _vm.toggleShop(shop.id)
                    },
                  },
                },
                [_c("span", { domProps: { innerHTML: _vm._s(shop.title) } })]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v(_vm._s(_vm.content.shops_and_services)),
      ]),
      _vm._v(" "),
      _vm._v(" "),
      _vm.noticeContent
        ? _c("template", { slot: "notice" }, [
            _c("span", { staticClass: "listMenu_link listMenu_link-notice" }, [
              _vm._v("\n      " + _vm._s(_vm.noticeContent) + "\n    "),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "resources/kiosk/scripts/components/listmenus/ShopMenu.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__